module.exports = __webpack_public_path__ + "img/Dreitv_tall.46d7ce38.png";